import React, { memo, useContext, useState } from 'react';
import ProductImage from '../ProductImage';
import { Button, Modal, ModalBody, ModalFooter, Table } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/ModalHeader';
import { faDownload, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';
import AuthContext from '../../authentication/AuthContext';
import { IconWrapper } from '../IconWrapper';

export default memo(function ProductInformation({ url, image, description }) {
    const [showDetails, setShowDetails] = useState(false);
    const [product, setProduct] = useState();
    const [showDownload, setShowDownload] = useState(true);
    const cas = useContext(AuthContext);

    let showModal = () => {
        axios
            .get(url, {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                setProduct(response.data);
                setShowDetails(true);
            });
    };

    return (
        <>
            <div onClick={showModal} className={'pointer'}>
                <ProductImage src={image} alt={'Brandbank image for ' + description} />
            </div>
            {product && (
                <Modal
                    show={showDetails}
                    size={'lg'}
                    onHide={() => setShowDetails(false)}
                    dialogClassName={'product-information-modal'}
                >
                    <ModalHeader closeButton>
                        <h2>Product Details</h2>
                    </ModalHeader>
                    <ModalBody>
                        <div className={'product-information-content flex'}>
                            <Table className={'product-information-table'}>
                                <tbody>
                                    <tr>
                                        <th>Supplier Code:</th>
                                        <td>{product.supplierCode}</td>
                                    </tr>
                                    <tr>
                                        <th>Product Code:</th>
                                        <td>{product.productCode}</td>
                                    </tr>
                                    <tr>
                                        <th>Barcode:</th>
                                        <td>{product.barcode}</td>
                                    </tr>
                                    <tr>
                                        <th>Outer Barcode:</th>
                                        <td>{product.outerBarcode}</td>
                                    </tr>
                                    <tr>
                                        <th>Description:</th>
                                        <td>{product.description.toUpperCase()}</td>
                                    </tr>
                                    <tr>
                                        <th>Unit Size:</th>
                                        <td>{product.unitSize}</td>
                                    </tr>
                                    <tr>
                                        <th>Case Size:</th>
                                        <td>{product.caseSize}</td>
                                    </tr>
                                    <tr>
                                        <th>Shelf Life:</th>
                                        <td>{product.shelfLife}</td>
                                    </tr>
                                    <tr>
                                        <th>Category:</th>
                                        <td>{product.category}</td>
                                    </tr>
                                    <tr>
                                        <th>Super Category:</th>
                                        <td>{product.superCategory}</td>
                                    </tr>
                                    <tr>
                                        <th>Promotional Flag:</th>
                                        <td>{product.promotionalFlag}</td>
                                    </tr>
                                    <tr>
                                        <th>VAT Rate:</th>
                                        <td>{product.vatRate}%</td>
                                    </tr>
                                    <tr>
                                        <th>Cost:</th>
                                        <td>£{product.cost.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <th>RSP:</th>
                                        <td>£{product.rsp.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <th>Margin:</th>
                                        <td>{product.margin.toFixed(2)}%</td>
                                    </tr>
                                    <tr>
                                        <th>Price Marked:</th>
                                        <td>{product.priceMarked}</td>
                                    </tr>
                                    {product.supplierMaxOrderQuantity && (
                                        <tr>
                                            <th>Max Order Quantity:</th>
                                            <td>{product.supplierMaxOrderQuantity}</td>
                                        </tr>
                                    )}
                                    {!!product.min && (
                                        <tr>
                                            <th>Minimum Quantity:</th>
                                            <td>{product.min}</td>
                                        </tr>
                                    )}
                                    {!!product.max && (
                                        <tr>
                                            <th>Maximum Quantity:</th>
                                            <td>{product.max}</td>
                                        </tr>
                                    )}
                                    {product.multiple && (
                                        <tr>
                                            <th>Minimum Increment:</th>
                                            <td>{product.multiple}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                            <div className={'product-information-image-column flex'}>
                                <div className={'product-information-image'}>
                                    <ProductImage
                                        src={product.images.length > 0 ? product.images[0].url : ''}
                                        alt={'Brandbank image for ' + product.productDescription}
                                        onImageError={() => setShowDownload(false)}
                                    />
                                </div>
                                {showDownload && !!product.images[1] && (
                                    <a
                                        href={product.images[1].url}
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                    >
                                        <Button variant={'primary'}>
                                            <IconWrapper icon={faDownload} />
                                            Download Image
                                        </Button>
                                    </a>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant={'secondary'} onClick={() => setShowDetails(false)}>
                            <IconWrapper icon={faTimesCircle} />
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
});
